import React, { FC, ReactElement, useCallback, useState } from 'react';

import TooltipWhite from '@buyside/components/presentation/Tooltips/TooltipWhite/tooltipWhite';
import Modal from '@buyside/components/presentation/Modal/modal';
import JobApplicationMessageForm, { ModalProps } from './JobApplicationMessageForm';

import styles from './JobApplicationShowModalStyles.scss';

const RejectModal: FC<ModalProps> = ({ renderOpenButton, name, handleSubmit }): ReactElement => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = useCallback(() => setIsModalOpen(true), []);

  return (
    <>
      <TooltipWhite overlay={<div>Reject Candidate</div>} placement="top">
        <span>{renderOpenButton(handleOpenModal)}</span>
      </TooltipWhite>
      <Modal
        id="reject"
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Reject Applicant"
      >
        <div className={styles.subtitle}>Please enter feedback to {name} (optional)</div>
        <JobApplicationMessageForm
          closeModal={() => setIsModalOpen(false)}
          handleSubmit={handleSubmit}
          submitButtonText="Reject"
        />
        <div className={styles.note}>
          <strong>Note: </strong>The rejected applicant will not be able to contact you through this
          message. Use this field to give the applicant optional feedback on his/her application.
        </div>
      </Modal>
    </>
  );
};

export default RejectModal;
